"use client"

import * as React from "react"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"
import ProfileIcon from "../images/profile_svg.svg"
import ProfileIconActive from "../images/profile_svg_active.svg"
import BadgeIcon from "../images/badge_svg.svg"
import BadgeIconActive from "../images/badge_svg_active.svg"
import SummaryIcon from "../images/summary_svg.svg"
import SummaryIconActive from "../images/summary_svg_active.svg"
import HistoryIcon from "../images/history_svg.svg"
import HistoryIconActive from "../images/history_svg_active.svg"

const MENU_ITEMS = [
  {
    to: "/profile",
    label: "Mi perfil",
    Icon: ProfileIcon,
    IconActive: ProfileIconActive,
  },
  {
    to: "/insignias",
    label: "Insignias",
    Icon: BadgeIcon,
    IconActive: BadgeIconActive,
  },
  {
    to: "/summary",
    label: "Resumen",
    Icon: SummaryIcon,
    IconActive: SummaryIconActive,
  },
  {
    to: "/history",
    label: "Historial",
    Icon: HistoryIcon,
    IconActive: HistoryIconActive,
  },
]

const CommunityContentLayout = ({ children, avatar, isPremium }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)
  const toggleMenu = () => setIsMenuOpen(open => !open)
  const showMobileView = !isMenuOpen
  const location = useLocation()
  const activeColor = "#00CEA9"
  const defaultColor = "#C4C4C4"

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Mobile Header */}
      <header className="md:hidden">
        {showMobileView && (
          <nav
            className="bg-black text-white pb-4"
            style={{ paddingTop: "180px" }}
          >
            <ul className="flex items-center justify-center">
              {MENU_ITEMS.map((item, idx) => {
                const active = location.pathname === item.to
                const Svg = active ? item.IconActive : item.Icon
                return (
                  <React.Fragment key={item.to}>
                    <li className="flex items-center px-2">
                      <Svg
                        width={24}
                        height={24}
                        fill={active ? activeColor : defaultColor}
                      />
                      <Link
                        to={item.to}
                        className={`text-xs ml-1 ${
                          active ? "text-[#00CEA9]" : "text-white"
                        }`}
                      >
                        {item.label}
                      </Link>
                    </li>
                    {idx < MENU_ITEMS.length - 1 && (
                      <li className="text-white">|</li>
                    )}
                  </React.Fragment>
                )
              })}
            </ul>
          </nav>
        )}
      </header>

      {/* Sidebar Desktop */}
      <aside
        className={`bg-black text-white p-8 w-full md:w-1/4 flex-shrink-0
          ${
            isMenuOpen
              ? "fixed inset-0 z-50 overflow-y-auto"
              : "hidden md:block static"
          }`}
      >
        {isMenuOpen && (
          <button
            onClick={toggleMenu}
            className="absolute top-4 right-4 text-white md:hidden"
          >
            X
          </button>
        )}
        <nav>
          <ul className="space-y-4">
            {MENU_ITEMS.map(item => {
              const active = location.pathname === item.to
              const Svg = active ? item.IconActive : item.Icon
              return (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    activeClassName="border-l-4 border-sc-primary"
                    className={`flex items-center px-4 py-2 hover:bg-gray-800 rounded ${
                      active ? "text-[#00CEA9]" : "text-white"
                    }`}
                  >
                    {item.to === "/profile" && avatar ? (
                      <img
                        src={avatar}
                        alt="Avatar"
                        className="w-8 h-8 rounded-full mr-4 object-cover"
                      />
                    ) : (
                      <Svg
                        width={24}
                        height={24}
                        fill={active ? activeColor : defaultColor}
                        className="mr-4"
                      />
                    )}
                    <span>{item.label}</span>
                  </Link>
                </li>
              )
            })}
            {isPremium && (
              <li>
                <Link
                  to="/preferences"
                  activeClassName="border-l-4 border-sc-primary"
                  className="flex items-center px-4 py-2 hover:bg-gray-800 rounded"
                >
                  <BadgeIcon
                    width={24}
                    height={24}
                    fill={defaultColor}
                    className="mr-4"
                  />
                  <span className="hover:text-[#00CEA9]">
                    Informe de gustos
                  </span>
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-8 mt-6 md:mt-0">{children}</main>
    </div>
  )
}

export default CommunityContentLayout
